/*
* Project: LegalPlace assistant
* File: src/components/buy/cart.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

/**
 * @description The cart class is meant to show the information of the purchase
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePromoCode, ckSendPromoCode, isClientPro } from '../../redux/actions/checkout_operations';
import { percentagePromo } from './pack_choice';
import PaymentModal from './payment_modal';
import LpCreditCardModal from './card_modal';
import lpevents from '../../tracking/lpevents';
import { lpPattern, P_CHECK_PROMO } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import {DEFAULT_CHECKOUT_FAQ, CONTRACTS_WITHOUT_CHECKOUT_META_ID} from '../../constants/default_checkout'

class _Cart extends Component {
  constructor(props) {

    super(props);

    this.scrollEvent = this.scrollEvent.bind(this);
    this.sendPromo = this.sendPromo.bind(this);
    this.showCreditCardModal = this.showCreditCardModal.bind(this);

    this.state = {
      show_modal: false,
      show_modal1: false,
    };
    lpApp.ops.checkout.setCheckoutCallback(this.showCreditCardModal);
  }

  componentWillUnmount() {
    window.onscroll = null;
  }

  showCreditCardModal() {
    // Tracking opened payment popup
    const eventParams = {};

    eventParams['Chosen price'] = parseFloat(lpApp.ops.checkout.getPackPrice());
    eventParams['Total price'] = parseFloat(lpApp.ops.checkout.getTTCPrice());
    eventParams['Chosen pack'] = (this.props.choosenPack === 0) ? 'first_price' : 'second_price';
    if (lpApp.subscription && this.props.choosenPack === 1) eventParams['Chosen pack'] = 'abonnement';

    lpevents.track('Opened Payment Popup', eventParams);
    lpevents.trackPopUpCheckout()
    if (lpApp.subscription && this.props.choosenPack === 1) {
      this.setState({
        show_modal1: true,
      });
    } else this.setState({ show_modal: true });
  }


  /**
     * @description show and hide the payment button when the other shows up.
     */
  scrollEvent() {
    const paymentButton = document.getElementById('payment_');

    if (paymentButton.getClientRects()[0].y <= (lpApp.env.client_zone.height - 35)) {
      this.refs.one.classList.add('animate-hide');
    } else {
      this.refs.one.classList.remove('animate-hide');
    }
  }

  sendPromo() {
    this.props.checkPromo(this.props.promo_code, lpApp.contractUniqid);
  }

  render() {
    isClientPro();
    const customCheckoutCta = lpApp.references.customs.custom ? lpApp.references.customs.custom.checkout_cta : ''
    return (
      <div className="sidebar lp-cart-ng" ref="do_stuff">
        <div>
          <div className="lp-cart">
            <a className="btn btn-block btn-primary cta-payement" ref="one" onClick={this.showCreditCardModal}>
              <i className="icn-lock" />
              {(typeof(customCheckoutCta) === 'string' && customCheckoutCta.trim().length > 0)
              ? customCheckoutCta
              : (this.props.pack_price === 0) && lpApp.subscription ? _lp('Tester gratuitement') : _lp('Payer et Télécharger')}
            </a>
            <div className="payement-methods-img hidden-xs" onClick={this.showCreditCardModal}>
              <img width="255" height="26" src="/wizard/img/checkout-methods.png" srcSet="/wizard/img/checkout-methods@2x.png 2x" />
            </div>

            <div className="ch-cart-section is-title chc-recap">
              <div className="chc-item">{_lp('Récapitulatif')}</div>
            </div>

            <div className="ch-cart-section">
              <div className="chc-item">
                {this.props.choosenPack === 0 ? _lp('Pack Basique')
                  : (this.props.pack_price === 0) && lpApp.subscription ? _lp('Abonnement Legalplace HT')
                    : _lp('Pack Complet HT')}
              </div>
              <div className="chc-price">
                {parseFloat(lpApp.ops.checkout.getHTPrice()).toFixed(2)}
                {' '}
                €
              </div>
            </div>
            <div className="ch-cart-section">
              <div className="chc-item">{_lp('TVA à 20%')}</div>
              <div className="chc-price">
                {(lpApp.ops.checkout.getTTCPrice() - lpApp.ops.checkout.getHTPrice()).toFixed(2)}
                {' '}
                €
              </div>
            </div>
            {(this.props.has_call || this.props.has_letter)}
            {this.props.has_call && (
            <div className="ch-cart-section">
              <div className="chc-item">{_lp('Question')}</div>
              <div className="chc-price">
                {(29.90 / 1.2).toFixed(2)}
                {' '}
                €
              </div>
            </div>
            )}
            {this.props.has_letter && (
            <div className="ch-cart-section">
              <div className="chc-item">{_lp('Envoie par courrier')}</div>
              <div className="chc-price">
                {(this.props.letter_number * 3.90 / 1.2).toFixed(2)}
€
              </div>
            </div>
            )}
            <div className="ch-cart-section is-bold chc-total">
              <div className="chc-item">Total TTC</div>
              {((!this.props.price_loading && !Number.isNaN(parseFloat(this.props.second_price)) && !Number.isNaN(parseFloat(this.props.first_price))) || !this.props.price_loading)
              && (
              <div className="chc-price">
                {lpApp.ops.checkout.getTTCPrice()}
                {' '}
                  €
              </div>
              )}
            </div>
          </div>

          <div className={`lp-cart-coupon${this.props.promo_code.length > 0 ? ' focus' : ''}`}>
            {(parseFloat(this.props.promo_percentage) === 0 || Number.isNaN(parseFloat(this.props.promo_percentage))) && (
              <form action="#">
                <input type="text" disabled={this.props.promo_loading} placeholder="Code promotionnel" className="form-control" onChange={evt => this.props.updatePromo(evt.target.value)} />
                <button disabled={this.props.promo_code.length <= 0} className={`btn${this.props.promo_loading ? ' checking' : ''}`} type="button" onClick={this.sendPromo}>
                  <span className="lpc-txt">Valider</span>
                  <span className="loading-spin" />
                </button>
                {typeof this.props.promo_percentage === 'string'
                  && (
                  <span className="help-block">
                    {this.props.promo_percentage}
                  </span>
                  )}
              </form>
              )}
              {(parseFloat(this.props.promo_percentage) > 0) && (
                <div className="lpcc-valid">
                  <span>
                    {_lp('Réduction de ') + (parseFloat(this.props.promo_percentage) * 100)}
                    {' '}
                    %
                  </span>
                  <i className="icn-checkmark" />
                </div>
              )}
          </div>
          <LpCreditCardModal
            show={this.state.show_modal}
            closeEvent={() => this.setState({ show_modal: false })}
          />
          <PaymentModal
            show={this.state.show_modal1}
            closeEvent={() => this.setState({ show_modal1: false })}
          />
        </div>
        <div className="lp-checkout-faq">
          {(CONTRACTS_WITHOUT_CHECKOUT_META_ID.indexOf(lpApp.contractMetaId) === -1 && lpApp.contractMetaId !== 302)  && DEFAULT_CHECKOUT_FAQ.map(faqElement => (
            <div key={faqElement.h3} className="lp-checkout-faq__element">
              <h3>
                {faqElement.h3}
              </h3>
              <p>
                {faqElement.p}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  title: state.contract.name,
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  choosenPack: state.checkout_operations.pack,
  has_call: state.checkout_operations.has_call,
  has_letter: state.checkout_operations.has_letter,
  letter_number: state.checkout_operations.letter.number,
  pack_price: state.checkout_operations.pack === 0
    ? state.checkout_operations.prices.first_price
    : state.checkout_operations.prices.second_price,
  promo_code: state.checkout_operations.promo_code,
  promo_loading: state.checkout_operations.promo_loading,
  promo_percentage: state.checkout_operations.promo_percentage,
  price_loading: state.loading_details.pricing,
  client_email: state.account_settings.mail,
});

const mapDispatchToProps = dispatch => ({
  updatePromo: (val) => {
    dispatch(ckUpdatePromoCode(val));
  },
  checkPromo: (val, contractId) => {
    dispatch(ckSendPromoCode(val, contractId));
    lpPattern.trackInPayment(P_CHECK_PROMO);
  },
});

const LpCart = connect(mapStateToProps, mapDispatchToProps)(_Cart);

export default LpCart;



// WEBPACK FOOTER //
// ./src/components/buy/cart.js